import Course from './Models/Course'
import Gallery from './Models/Gallery'
import Testimonial from './Models/Testimonial'

Vue.prototype.$models.$course = new Vue(Course)
Vue.prototype.$models.$gallery = new Vue(Gallery)
Vue.prototype.$models.$testimonial = new Vue(Testimonial)

Vue.component('courses-form', () => import(/* webpackChunkName: "courses-form" */ '@modulesPages/Site/Resources/assets/js/Forms/Courses/CoursesForm'))
Vue.component('galleries-form', () => import(/* webpackChunkName: "galleries-form" */ '@modulesPages/Site/Resources/assets/js/Forms/Galleries/GalleriesForm'))
Vue.component('testimonials-form', () => import(/* webpackChunkName: "testimonials-form" */ '@modulesPages/Site/Resources/assets/js/Forms/Testimonials/TestimonialsForm'))

Vue.component('courses-table', () => import(/* webpackChunkName: "courses-table" */ '@modulesPages/Site/Resources/assets/js/Tables/CoursesTable'))
Vue.component('galleries-table', () => import(/* webpackChunkName: "galleries-table" */ '@modulesPages/Site/Resources/assets/js/Tables/GalleriesTable'))
Vue.component('testimonials-table', () => import(/* webpackChunkName: "testimonials-table" */ '@modulesPages/Site/Resources/assets/js/Tables/TestimonialsTable'))

Vue.component('gallery-card', () => import(/* webpackChunkName: "gallery-card" */ '@modulesPages/Site/Resources/assets/js/Cards/GalleryCard'))
